export const ROLE = {
    ADMIN: 1, // 管理者
    APPROVER: 2, // 承認者
    GENERAL: 3, // 一般
  } as const